import { SectionLoader } from '@/shared/components/section-loader';
export const TrackerTeamLoading = () => {
  return <SectionLoader />;
};
